import { render, staticRenderFns } from "./SandboxPage.vue?vue&type=template&id=d27b7528&scoped=true&"
import script from "./SandboxPage.vue?vue&type=script&lang=ts&"
export * from "./SandboxPage.vue?vue&type=script&lang=ts&"
import style0 from "./SandboxPage.vue?vue&type=style&index=0&id=d27b7528&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d27b7528",
  null
  
)

export default component.exports